import React from 'react';
import { connect } from 'react-redux';
import { setIsOnlyAudio } from '../../stories/actions';
import * as roomRTC from "../../services/roomRTC";

const ButtonMic = ({ isOnlyAudio, setIsOnlyAudioAction }) => {
    const handlerStateMic = () => {
        setIsOnlyAudioAction(!isOnlyAudio);
        
        let audioActive = isOnlyAudio ? false : true;

        roomRTC.toggleAudioConnect(audioActive);
    };

    return (
        <div className="btn_mic_circle" onClick={handlerStateMic}>
            {isOnlyAudio ?
                <span className="material-symbols-outlined btn_icon_style" title='Microfone ligado'>mic</span> :
                <span className="material-symbols-outlined btn_icon_style" title='Microfone desligado'>mic_off</span>}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        ...state
    };
};

const mapStateActionToProps = (dispatch) => {
    return {
        setIsOnlyAudioAction: (isOnlyAudio) => dispatch(setIsOnlyAudio(isOnlyAudio)),
    };
};

export default connect(mapStateToProps, mapStateActionToProps)(ButtonMic);